export const environment = {
    env: 'DEV',
    production: true,
    API_URL: "https://api-dev.easyorderapp.com",
    EMBED_URL: "https://embed-dev.easyorderapp.com",
    SAMPLE_RATE: 0.1
};
